import { render, staticRenderFns } from "./StudentQuizKti.vue?vue&type=template&id=0fa6c076"
import script from "./StudentQuizKti.vue?vue&type=script&lang=js"
export * from "./StudentQuizKti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports